import React from "react";
import styled from "styled-components";
import withTheme from "./hoc/withTheme";
import { Header, Banner } from "./components";

const App = props => {
  const { theme } = props;
  return (
    <Container theme={theme}>
      <Header />
      <Banner />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  height: 100%;
  background: ${props => props.theme.colors.background.ambient};
`;

export default withTheme(App);
